import { Module } from '@nestjs/common';

import { ApplicationExceptionHandler } from '@project-management-system/backend-utils';
import { TypeOrmModule } from '@nestjs/typeorm';
import { CartonBoxService } from './carton-box-services';
import { CartonBoxEntity } from './entity/carton-box.entity';
import { CartonBoxController } from './carton-box-controller';
import { CartonBoxAdapter } from './adapters/carton-box.adapter';
import { CartonBoxRepository } from './repository/carton-box.repo';


@Module({
  providers: [CartonBoxService, ApplicationExceptionHandler,CartonBoxRepository,CartonBoxAdapter],
  imports: [
    TypeOrmModule.forFeature([
        CartonBoxEntity
  ])],
  controllers: [CartonBoxController],
  exports:[CartonBoxService]
})
export class CartonBoxModule { }
